/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	AddNotificationTextCommand,
	AddOrChangeModuleProductIndividualCommand,
	AddReleaseNoteCommand,
	AddTrainingCommand,
	AnnulServiceAgreementCommand,
	BusinessPartnerDto,
	CheckIfEmailUsedQuery,
	ClaimHistoryInfoDto,
	CommentDto,
	CommissioningDto,
	ComponentAndSoftwareDto,
	ConcernedIndividualCampaignDto,
	ConnectEndCustomerToUnitRequest,
	ConnectedUnit,
	ConsentDto,
	CountryInfoDto,
	CoverageCodeDto,
	CreateAdditionalFilesCommand,
	CreateEndCustomerCommand,
	CreateForeignProductIndividualCommentCommand,
	CreateOrUpdateCommissioningCommand,
	CreateOrUpdateServiceAgreementCommand,
	CreateOrUpdateUnitLocationCommand,
	CreateProductIndividualCommentCommand,
	CreateScheduledMaintenanceAlertCommand,
	CreateUpdateProductInOperationCommand,
	DemoUseDto,
	DocumentDto,
	DomainErrorResponse,
	DrivelineControlSystemInfo,
	DrivelineCoveragesDto,
	DrivelineViewDto,
	EditProductIndividualCommand,
	EditTechnicalInfoForIndividualCommand,
	EditUnitConfigurationCommand,
	EndCustomerDto,
	EndCustomerSearchResponseDto,
	ErrorResponse,
	EvcUnitStatusResponse,
	EventLogDto,
	FinalizeHealthCheckCommand,
	FinalizeOfflineServiceProtocolCommand,
	FinalizeOnlineServiceProtocolCommand,
	GetDrivelineMaintenancePlansQuery,
	GetProductPopulationQuery,
	GetServiceProtocolInitialDatesDto,
	HealthCheckDto,
	HealthCheckFilesDto,
	HealthCheckListDto,
	HealthChecksAcceptedValues,
	IdLabelSortedDto,
	ImportAdditionalFilesToHealthCheckCommand,
	ImportAdditionalFilesToServiceAgreementCommand,
	InstallationPurpose,
	InstallationTypeDto,
	Kit,
	ListItemDto,
	ListItemParentDto,
	MainSegment,
	MainSegmentNames,
	MaintenancePlansResponse,
	MenuDto,
	ModelDto,
	ModifyTreeAddPartForSaleCommand,
	ModifyTreeAddProductIndividualBranchCommand,
	ModifyTreeMatchOutOfCalloffProductsCommand,
	ModifyTreeMatchPartForSaleCommand,
	ModifyTreeMatchProductIndividualCommand,
	ModuleDto,
	NodeType,
	NotFoundErrorResponse,
	OrderInfoDto,
	OrderInfoForSerialDto,
	OrderInfoProductIndividualViewDto,
	OwnerAndUnitManagerDto,
	PCReleaseNoteContent,
	PCReleaseNoteList,
	PartForSaleDto,
	PcTraining,
	ProductCategory,
	ProductInOperationDto,
	ProductIndividualCampaignsContractDto,
	ProductIndividualEditDto,
	ProductIndividualItemPurposeExtended,
	ProductIndividualPartDto,
	ProductIndividualSearchDtoResult,
	ProductIndividualWithRelatedEntities,
	ProductPopulationExportHeaderDto,
	ProductPopulationResponse,
	PublicationDto,
	RecentlyVisitedCommand,
	RegisterDemoUseCommand,
	RegistrationItemDto,
	RemoveReleaseNoteCommand,
	RepairDto,
	RepairHistoryDto,
	ReplaceProductIndividualCommand,
	ResetVmmCommand,
	ReviveProductIndividualCommand,
	SaveHealthCheckDraftCommand,
	SaveOnlineServiceProtocolDraftCommand,
	SaveUserSettingsCommandStringBoolean,
	SaveUserSettingsCommandTabsTypesIListString,
	ScheduledMaintenanceAlertDto,
	ScrapProductIndividualCommand,
	SearchProductIndividualDto,
	SearchProductMaintenancePlannerDto,
	SecurityMatrixDto,
	SelectItemDto,
	ServiceActivityEventsInfoDto,
	ServiceAgreementDto,
	ServiceAgreementFileDto,
	ServiceDto,
	ServiceProtocolDto,
	SetUserLanguageCommand,
	SetUserRolesCommand,
	SettingsCategory,
	SoftwareParameterDto,
	StatesAndProvinces,
	StatesAndProvincesDto,
	SupportedCountryCodeDto,
	SupportedLanguageDto,
	SwapIndividualInDrivelinesCommand,
	TechnicalInfoDto,
	TelephoneCountryCodeDto,
	TempFileUploadDto,
	UnitIds,
	UnitInfoDto,
	UnitInfoDtoBase,
	UnitOtherPartsDto,
	UnitRegisterCommand,
	UnitRegisterGRCommand,
	UnitRegistrationModelGR,
	UnitRegistrationSummaryDto,
	UnitRelocateToCommand,
	UnitStructureDto,
	UpdateEndCustomerCommand,
	UpdateNotificationTextCommand,
	UpdateOtherPartsForUnitCommand,
	UpdateReleaseNoteCommand,
	UpdateScheduledMaintenanceAlertCommand,
	UploadProductIndividualCommand,
	UserRecentlyVisitedDto,
	UserTabsSettingsDto,
	UserVisibilitySettingsDto,
	UserWithCustomerDto,
	VSTCodeDto,
	ValidationErrorResponse,
	ValidationFailure,
	VariantComparison,
	WarrantyVerification,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class V1<
	SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
	/**
	 * @description Most of the time it is information about the upcoming update.
	 *
	 * @tags Configuration
	 * @name GetNotificationText
	 * @summary Get current notification text.
	 * @request GET:/v1/configuration/notification-text
	 * @secure
	 */
	getNotificationText = (params: RequestParams = {}) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/configuration/notification-text`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name AddNotificationText
	 * @summary Add new notification text
	 * @request POST:/v1/configuration/notification-text
	 * @secure
	 */
	addNotificationText = (
		data: AddNotificationTextCommand,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/configuration/notification-text`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name UpdateNotificationText
	 * @summary Update notification text
	 * @request PUT:/v1/configuration/notification-text
	 * @secure
	 */
	updateNotificationText = (
		data: UpdateNotificationTextCommand,
		params: RequestParams = {}
	) =>
		this.request<string, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/configuration/notification-text`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name RemoveNotificationText
	 * @summary Remove notification text
	 * @request DELETE:/v1/configuration/notification-text
	 * @secure
	 */
	removeNotificationText = (params: RequestParams = {}) =>
		this.request<void, void | ErrorResponse>({
			path: `/v1/configuration/notification-text`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetHullIdStandards
	 * @summary Get standard Volvo hull id types
	 * @request GET:/v1/configuration/hull-id-standard
	 * @secure
	 */
	getHullIdStandards = (
		query: {
			countryCode: string;
		},
		params: RequestParams = {}
	) =>
		this.request<SelectItemDto[], void | ErrorResponse>({
			path: `/v1/configuration/hull-id-standard`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetLengthUnits
	 * @summary Get standard Volvo length units.
	 * @request GET:/v1/configuration/length-units
	 * @secure
	 */
	getLengthUnits = (
		query?: {
			countryCode?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<SelectItemDto[], void | ErrorResponse>({
			path: `/v1/configuration/length-units`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetWeightUnits
	 * @summary Get standard Volvo weight units.
	 * @request GET:/v1/configuration/weight-units
	 * @secure
	 */
	getWeightUnits = (
		query?: {
			countryCode?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<SelectItemDto[], void | ErrorResponse>({
			path: `/v1/configuration/weight-units`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetCountryList
	 * @summary Get list of all countries.
	 * @request GET:/v1/configuration/country-infos
	 * @secure
	 */
	getCountryList = (
		query?: {
			languageCountryCode?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<CountryInfoDto[], void | ErrorResponse>({
			path: `/v1/configuration/country-infos`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetStatesAndProvincesList
	 * @summary Get list of all states or provinces.
	 * @request GET:/v1/configuration/states-provinces
	 * @secure
	 */
	getStatesAndProvincesList = (
		query?: {
			statesAndProvinces?: StatesAndProvinces;
		},
		params: RequestParams = {}
	) =>
		this.request<StatesAndProvincesDto[], void | ErrorResponse>({
			path: `/v1/configuration/states-provinces`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetNotificationLanguages
	 * @summary Get list of Volvo GDPR notification languages.
	 * @request GET:/v1/configuration/notification-languages
	 * @secure
	 */
	getNotificationLanguages = (params: RequestParams = {}) =>
		this.request<string[], void | ErrorResponse>({
			path: `/v1/configuration/notification-languages`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name GetTrainings
	 * @summary Get list of Product Center trainings.
	 * @request GET:/v1/configuration/trainings
	 * @secure
	 */
	getTrainings = (params: RequestParams = {}) =>
		this.request<PcTraining[], void | ErrorResponse>({
			path: `/v1/configuration/trainings`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name AddTraining
	 * @summary Add new new training
	 * @request POST:/v1/configuration/trainings
	 * @secure
	 */
	addTraining = (data: AddTrainingCommand, params: RequestParams = {}) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/configuration/trainings`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Configuration
	 * @name RemoveTraining
	 * @summary Remove training
	 * @request DELETE:/v1/configuration/trainings/{trainingId}
	 * @secure
	 */
	removeTraining = (trainingId: number, params: RequestParams = {}) =>
		this.request<void, void | ErrorResponse>({
			path: `/v1/configuration/trainings/${trainingId}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Driveline
	 * @name GetDrivelineStructureById
	 * @summary Get driveline information with children structure.
	 * @request GET:/v1/driveline/{id}/structure
	 * @secure
	 */
	getDrivelineStructureById = (id: number, params: RequestParams = {}) =>
		this.request<
			DrivelineViewDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/driveline/${id}/structure`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Driveline
	 * @name GetDrivelineId
	 * @summary Get driveline information with children structure.
	 * @request GET:/v1/driveline/id
	 * @secure
	 */
	getDrivelineId = (
		query: {
			chassisSeries: string;
			/** @format int32 */
			chassisNumber: number;
		},
		params: RequestParams = {}
	) =>
		this.request<number, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/driveline/id`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Driveline
	 * @name GetDrivelineVariants
	 * @summary Get driveline variants from VDA.
	 * @request GET:/v1/driveline/{id}/variants
	 * @secure
	 */
	getDrivelineVariants = (id: number, params: RequestParams = {}) =>
		this.request<
			VariantComparison,
			DomainErrorResponse | void | string | ErrorResponse
		>({
			path: `/v1/driveline/${id}/variants`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will only contain cancelled protocols, if the requestor has the access rights.
	 *
	 * @tags Driveline
	 * @name GetDrivelineServiceProtocols
	 * @summary Get service protocols for driveline.
	 * @request GET:/v1/driveline/{id}/service-protocol
	 * @secure
	 */
	getDrivelineServiceProtocols = (id: number, params: RequestParams = {}) =>
		this.request<
			ServiceProtocolDto[],
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/driveline/${id}/service-protocol`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Driveline
	 * @name GetDrivelineCoverages
	 * @summary Get list of driveline warranty coverages.
	 * @request GET:/v1/driveline/{id}/coverages
	 * @secure
	 */
	getDrivelineCoverages = (id: number, params: RequestParams = {}) =>
		this.request<CoverageCodeDto[], void | ErrorResponse>({
			path: `/v1/driveline/${id}/coverages`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description * Return campaigns filtered for dealer or internal user * Additionally returns link to campaign publication, but only the VPPC one.
	 *
	 * @tags Driveline
	 * @name GetDrivelineCampaignsWithoutPolicy
	 * @summary Return campaigns, except for policy type, for product individuals in the driveline.
	 * @request GET:/v1/driveline/{id}/campaigns
	 * @secure
	 */
	getDrivelineCampaignsWithoutPolicy = (
		id: number,
		query?: {
			/** If result set should contain concerned individuals with campaigns performed */
			includePerformed?: boolean;
			/** If result set should contain closed campaigns */
			includeClosed?: boolean;
			/** Get campaigns for internal roles or for external roles */
			queryAsExternal?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<ConcernedIndividualCampaignDto[], void | ErrorResponse>({
			path: `/v1/driveline/${id}/campaigns`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name GetTelephoneCountryCodes
	 * @summary Returns telephone prefixes with country codes
	 * @request GET:/v1/ecm/dictionaries/telephone-country-codes
	 * @secure
	 */
	getTelephoneCountryCodes = (params: RequestParams = {}) =>
		this.request<TelephoneCountryCodeDto[], void>({
			path: `/v1/ecm/dictionaries/telephone-country-codes`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name GetSupportedLanguages
	 * @summary Returns supported languages for consents
	 * @request GET:/v1/ecm/dictionaries/supported-languages
	 * @secure
	 */
	getSupportedLanguages = (params: RequestParams = {}) =>
		this.request<SupportedLanguageDto[], void>({
			path: `/v1/ecm/dictionaries/supported-languages`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name GetSupportedCountryCodes
	 * @summary Returns supported country codes for EndCustomer address
	 * @request GET:/v1/ecm/dictionaries/supported-country-codes
	 * @secure
	 */
	getSupportedCountryCodes = (params: RequestParams = {}) =>
		this.request<SupportedCountryCodeDto[], void>({
			path: `/v1/ecm/dictionaries/supported-country-codes`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name GetApplicableConsents
	 * @summary Returns available consents with translations for given language
	 * @request GET:/v1/ecm/consents/available-consents
	 * @secure
	 */
	getApplicableConsents = (
		query: {
			languageCode: string;
			consentVersion?: string | null;
		},
		params: RequestParams = {}
	) =>
		this.request<ConsentDto[], void>({
			path: `/v1/ecm/consents/available-consents`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name GetEndCustomer
	 * @summary Returns end customer basing on identifier
	 * @request GET:/v1/ecm/end-customer
	 * @secure
	 */
	getEndCustomer = (
		query: {
			/**
			 * The unique identifier of the end customer to retrieve.
			 * @format int32
			 */
			endCustomerId: number;
		},
		params: RequestParams = {}
	) =>
		this.request<EndCustomerDto, void>({
			path: `/v1/ecm/end-customer`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Email has to be put in the body, as it is sensitive data
	 *
	 * @tags Ecm
	 * @name GetEmailIsNotUsed
	 * @summary Check if email is available, for consumer/end customer creation process
	 * @request POST:/v1/ecm/end-customer/email-availability
	 * @secure
	 */
	getEmailIsNotUsed = (
		data: CheckIfEmailUsedQuery,
		params: RequestParams = {}
	) =>
		this.request<boolean, void>({
			path: `/v1/ecm/end-customer/email-availability`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name SearchEndCustomers
	 * @summary Searches end customers basing on properties
	 * @request GET:/v1/ecm/end-customer/search
	 * @secure
	 */
	searchEndCustomers = (
		query?: {
			/**
			 * Ignored and set to 10 if User is external
			 * @format int32
			 */
			resultsCount?: number | null;
			/** Name */
			firstName?: string | null;
			/** Surname */
			surname?: string | null;
			/** AddressFirstPart */
			addressFirstPart?: string | null;
			/** AddressSecondPart */
			addressSecondPart?: string | null;
			/** City */
			city?: string | null;
			/** County */
			county?: string | null;
			/** CountryCode */
			countryCode?: string | null;
			/** CompanyName */
			companyName?: string | null;
			/** Email */
			email?: string | null;
			/** PhoneNumber */
			phone?: string | null;
			/** 2 characters country code prefix for phone number */
			phonePrefixCountryCode?: string | null;
			/** PostalCode */
			postalCode?: string | null;
			/** VatNumber */
			vatNumber?: string | null;
			/** Title, f.e. Mr., Ms. etc */
			title?: string | null;
			/** This will perform the search only within provided customer ids */
			endCustomerIds?: number[] | null;
		},
		params: RequestParams = {}
	) =>
		this.request<EndCustomerSearchResponseDto, void>({
			path: `/v1/ecm/end-customer/search`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name CreateEndCustomer
	 * @summary Creates end customer
	 * @request POST:/v1/ecm/end-customer/create
	 * @secure
	 */
	createEndCustomer = (
		data: CreateEndCustomerCommand,
		params: RequestParams = {}
	) =>
		this.request<EndCustomerDto, void>({
			path: `/v1/ecm/end-customer/create`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name UpdateEndCustomer
	 * @summary Updates existing end customer
	 * @request PUT:/v1/ecm/end-customer/update
	 * @secure
	 */
	updateEndCustomer = (
		data: UpdateEndCustomerCommand,
		params: RequestParams = {}
	) =>
		this.request<EndCustomerDto, void>({
			path: `/v1/ecm/end-customer/update`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name ConnectCustomerToUnit
	 * @summary Connect an owner and an optional unit manager - a special customer type, that is connected to unit managing role.
	 * @request POST:/v1/ecm/end-customer/connect
	 * @secure
	 */
	connectCustomerToUnit = (
		data: ConnectEndCustomerToUnitRequest,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/ecm/end-customer/connect`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Ecm
	 * @name DisconnectUnitManagerFromUnit
	 * @summary Disconnect a unit manager - a special customer type, that is connected to unit managing role.
	 * @request POST:/v1/ecm/end-customer/disconnect
	 * @secure
	 */
	disconnectUnitManagerFromUnit = (
		query?: {
			/**
			 * Numeric identifier of the unit manager to remove from the unit.
			 * @format int32
			 */
			unitManagerId?: number;
			/**
			 * Numeric identifier of the unit the manager is currently connected to.
			 * @format int64
			 */
			unitId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<void, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/ecm/end-customer/disconnect`,
			method: 'POST',
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadFile
	 * @summary Download file. POST request, to handle token passed in body
	 * @request POST:/v1/file
	 * @secure
	 */
	downloadFile = (
		query: {
			/** @format int32 */
			fileSetId: number;
			/** @format int32 */
			fileId: number;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file`,
			method: 'POST',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name RemoveFile
	 * @summary Remove file for provided file set id and file id
	 * @request DELETE:/v1/file
	 * @secure
	 */
	removeFile = (
		query: {
			/** @format int32 */
			fileSetId: number;
			/** @format int32 */
			fileId: number;
			/** @format int64 */
			unitId: number;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadHealthCheckDocument
	 * @summary Download health check document. POST request, to handle token passed in body
	 * @request POST:/v1/file/health-check/{fileId}
	 * @secure
	 */
	downloadHealthCheckDocument = (
		fileId: number,
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/health-check/${fileId}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadDocument
	 * @summary Download document. POST request, to handle token passed in body
	 * @request POST:/v1/file/document/{id}
	 * @secure
	 */
	downloadDocument = (id: number, params: RequestParams = {}) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/document/${id}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadServiceProtocolFile
	 * @summary Download service protocol file. POST request, to handle token passed in body
	 * @request POST:/v1/file/service-protocol/{fileId}
	 * @secure
	 */
	downloadServiceProtocolFile = (
		fileId: number,
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/service-protocol/${fileId}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name UploadServiceAgreementFiles
	 * @summary Uploads one service agreement files for a unit.
	 * @request POST:/v1/file/service-agreement/files
	 * @secure
	 */
	uploadServiceAgreementFiles = (
		data: {
			/**
			 * Gets the identifier of the unit that the uploaded file belongs to.
			 * @format int64
			 */
			unitId?: number;
			/**
			 * Gets the file that should be uploaded as the service agreement.
			 * @format binary
			 */
			file?: File;
			/** Gets an optional comment describing the service agreement. */
			comment?: string;
			/** Gets a value indicating whether the uploaded service agreement should be visible to external users. */
			isPublic?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<void, string | void | ErrorResponse>({
			path: `/v1/file/service-agreement/files`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name GetServiceAgreementFiles
	 * @summary Retrieves all service agreement files associated with the specified unit.
	 * @request GET:/v1/file/service-agreement/files/unit/{unitId}
	 * @secure
	 */
	getServiceAgreementFiles = (unitId: number, params: RequestParams = {}) =>
		this.request<ServiceAgreementFileDto[], string | void | ErrorResponse>({
			path: `/v1/file/service-agreement/files/unit/${unitId}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadServiceAgreementFiles
	 * @summary Downloads a specific service agreement file by its identifier.
	 * @request POST:/v1/file/service-agreement/files/{serviceAgreementFileId}
	 * @secure
	 */
	downloadServiceAgreementFiles = (
		serviceAgreementFileId: number,
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/service-agreement/files/${serviceAgreementFileId}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DeleteServiceAgreementFile
	 * @summary Deletes a specific service agreement file by its identifier.
	 * @request DELETE:/v1/file/service-agreement/files/{serviceAgreementFileId}
	 * @secure
	 */
	deleteServiceAgreementFile = (
		serviceAgreementFileId: number,
		params: RequestParams = {}
	) =>
		this.request<void, string | void | ErrorResponse>({
			path: `/v1/file/service-agreement/files/${serviceAgreementFileId}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
 * No description
 *
 * @tags File
 * @name ImportAdditionalFilesToServiceAgreement
 * @summary Import files from a unit's additional-files FileSet into service agreement files.
No physical file move is performed — both file types share the same storage path.
 * @request POST:/v1/file/{unitId}/additional-files/import-to-service-agreement
 * @secure
 */
	importAdditionalFilesToServiceAgreement = (
		unitId: number,
		data: ImportAdditionalFilesToServiceAgreementCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/file/${unitId}/additional-files/import-to-service-agreement`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name UploadHealthCheckFiles
	 * @summary Uploads one or more health check files for a unit. All uploaded files are grouped into a single file set.
	 * @request POST:/v1/file/health-check/files
	 * @secure
	 */
	uploadHealthCheckFiles = (
		data: {
			/** @format int64 */
			unitId?: number;
			files?: File[];
			comment?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/file/health-check/files`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadHealthCheckFile
	 * @summary Download health check file. POST request, to handle token passed in body.
	 * @request POST:/v1/file/health-check/files/{fileId}
	 * @secure
	 */
	downloadHealthCheckFile = (fileId: number, params: RequestParams = {}) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/health-check/files/${fileId}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DeleteHealthCheckFile
	 * @summary Deletes a specific health check file for the provided unit and file id.
	 * @request DELETE:/v1/file/health-check/files/unit/{unitId}/{fileId}
	 * @secure
	 */
	deleteHealthCheckFile = (
		unitId: number,
		fileId: number,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			string | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/file/health-check/files/unit/${unitId}/${fileId}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadPerformedOperationImage
	 * @summary Download service protocol performed operation image
	 * @request GET:/v1/file/performed-operation-image/{imageId}
	 * @secure
	 */
	downloadPerformedOperationImage = (
		imageId: number,
		query?: {
			/** Which thumbnail size should be returned. */
			size?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/performed-operation-image/${imageId}`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags File
	 * @name DownloadImage
	 * @summary Download picture
	 * @request GET:/v1/file/image/{id}
	 * @secure
	 */
	downloadImage = (
		id: number,
		query?: {
			/** Which thumbnail size should be returned. */
			size?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/file/image/${id}`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description * Can be used during registration process and later sent paths, when finishing process. * Is available for any authenticated user. * If this is first file, pass empty value for attachment folder. For any subsequent file use returned value from first request.
	 *
	 * @tags File
	 * @name UploadTemporaryFile
	 * @summary UploadTemporaryFile temporary document.
	 * @request POST:/v1/file/upload-temporary-file
	 * @secure
	 */
	uploadTemporaryFile = (
		data: {
			/**
			 * File content
			 * @format binary
			 */
			file?: File;
		},
		query?: {
			/** Attachment folder. */
			attachmentsFolder?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<TempFileUploadDto, string | void | ErrorResponse>({
			path: `/v1/file/upload-temporary-file`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description Is available for any authenticated user.
	 *
	 * @tags File
	 * @name UploadErrorFile
	 * @summary UploadTemporaryFile error file generated by FE application
	 * @request POST:/v1/file/upload-error-file
	 * @secure
	 */
	uploadErrorFile = (
		data: {
			/**
			 * File containing errors.
			 * @format binary
			 */
			file?: File;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, string | void | ErrorResponse>({
			path: `/v1/file/upload-error-file`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description * Can be used during registration process, after which folder name can be sent as parameter. * If this is first file, pass empty value for attachment folder. * For any subsequent file use returned value from first request.
	 *
	 * @tags File
	 * @name UploadTemporaryPicture
	 * @summary UploadTemporaryFile picture to temporary folder.
	 * @request POST:/v1/file/upload-temporary-picture
	 * @secure
	 */
	uploadTemporaryPicture = (
		data: {
			/**
			 * Image content
			 * @format binary
			 */
			image?: File;
		},
		query?: {
			/** Attachment folder */
			attachmentsFolder?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<TempFileUploadDto, string | void | ErrorResponse>({
			path: `/v1/file/upload-temporary-picture`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name SearchIndividual
	 * @summary Get candidate Position and Entity tree of a new Unit based on Blueprint
	 * @request GET:/v1/GuidedRegistration/SearchIndividual
	 * @secure
	 */
	searchIndividual = (
		query?: {
			/** Serial number of the ProductIndividual that is part of new Unit */
			serialNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | void | ErrorResponse>({
			path: `/v1/GuidedRegistration/SearchIndividual`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name SearchIndividualOnly
	 * @summary Get Product Individual for ad-hoc match by SerialNumber
	 * @request GET:/v1/GuidedRegistration/SearchIndividualOnly
	 * @secure
	 */
	searchIndividualOnly = (
		query?: {
			/** Serial number of the ProductIndividual that is part of new Unit */
			serialNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualWithRelatedEntities,
			string | void | ErrorResponse
		>({
			path: `/v1/GuidedRegistration/SearchIndividualOnly`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name RegisterUnitTree
	 * @summary Register new unit.
	 * @request POST:/v1/GuidedRegistration/RegisterUnitTree
	 * @secure
	 */
	registerUnitTree = (
		data: UnitRegisterGRCommand,
		params: RequestParams = {}
	) =>
		this.request<
			UnitRegistrationSummaryDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/GuidedRegistration/RegisterUnitTree`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
 * No description
 *
 * @tags GuidedRegistration
 * @name ModifyTreeMatchProductIndividual
 * @summary Send in the Registration Model and list of ProductIndividual matches to be applied to it (sequentially).
Each match contains Position Id and matched ProductIndividual.
 * @request POST:/v1/GuidedRegistration/ModifyTree/MatchProductIndividual
 */
	modifyTreeMatchProductIndividual = (
		data: ModifyTreeMatchProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | ErrorResponse>({
			path: `/v1/GuidedRegistration/ModifyTree/MatchProductIndividual`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
 * No description
 *
 * @tags GuidedRegistration
 * @name ModifyTreeMatchPartForSale
 * @summary Send in the Registration Model and list of PartForSales matches to be applied to it (sequentially).
Each match contains Position Id and matched PartForSale.
 * @request POST:/v1/GuidedRegistration/ModifyTree/MatchPartForSale
 */
	modifyTreeMatchPartForSale = (
		data: ModifyTreeMatchPartForSaleCommand,
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | ErrorResponse>({
			path: `/v1/GuidedRegistration/ModifyTree/MatchPartForSale`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name ModifyTreeMatchOutOfCalloffProductCommand
	 * @summary Send in the Registration Model and an arbitrary ProductIndividual to be matched to specific position
	 * @request POST:/v1/GuidedRegistration/ModifyTree/MatchOutOfCalloffProductIndividual
	 */
	modifyTreeMatchOutOfCalloffProductCommand = (
		data: ModifyTreeMatchOutOfCalloffProductsCommand,
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | ErrorResponse>({
			path: `/v1/GuidedRegistration/ModifyTree/MatchOutOfCalloffProductIndividual`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name ModifyTreeAddProductIndividualBranch
	 * @summary Send in the Registration Model, Product Individual with related Entities and Position Id to append new subtree to
	 * @request POST:/v1/GuidedRegistration/ModifyTree/AddProductIndividualBranch
	 */
	modifyTreeAddProductIndividualBranch = (
		data: ModifyTreeAddProductIndividualBranchCommand,
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | ErrorResponse>({
			path: `/v1/GuidedRegistration/ModifyTree/AddProductIndividualBranch`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags GuidedRegistration
	 * @name ModifyTreeAddPartForSale
	 * @summary Send in the Registration Model, PartForSale and Position Id to append new subtree to
	 * @request POST:/v1/GuidedRegistration/ModifyTree/AddPartForSale
	 */
	modifyTreeAddPartForSale = (
		data: ModifyTreeAddPartForSaleCommand,
		params: RequestParams = {}
	) =>
		this.request<UnitRegistrationModelGR, string | ErrorResponse>({
			path: `/v1/GuidedRegistration/ModifyTree/AddPartForSale`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags HealthCheck
	 * @name GetHealthChecks
	 * @summary Gets all health checks.
	 * @request GET:/v1/health-checks
	 * @secure
	 */
	getHealthChecks = (
		query?: {
			/** Unit public id */
			unitPublicId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<HealthCheckListDto[], void | ErrorResponse>({
			path: `/v1/health-checks`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags HealthCheck
	 * @name GetHealthCheck
	 * @summary Gets the full detail of a single health check including activities and files.
	 * @request GET:/v1/health-checks/{id}
	 * @secure
	 */
	getHealthCheck = (id: number, params: RequestParams = {}) =>
		this.request<
			HealthCheckDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/health-checks/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
 * No description
 *
 * @tags HealthCheck
 * @name DeleteHealthCheck
 * @summary Deletes a health check protocol.
External dealers can delete any protocol created by their organization.
Internal users can delete any protocols.
 * @request DELETE:/v1/health-checks/{id}
 * @secure
 */
	deleteHealthCheck = (id: number, params: RequestParams = {}) =>
		this.request<void, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/health-checks/${id}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags HealthCheck
	 * @name GetActivityNames
	 * @summary Gets the list of available health check activity names.
	 * @request GET:/v1/health-checks/activity-names
	 * @secure
	 */
	getActivityNames = (
		query?: {
			/** Unit public id */
			publicUnitId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<HealthChecksAcceptedValues, void | ErrorResponse>({
			path: `/v1/health-checks/activity-names`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags HealthCheck
	 * @name SaveHealthCheckDraft
	 * @summary Saves a health check protocol draft. Creates a new protocol when Id is null, otherwise updates the existing one.
	 * @request POST:/v1/health-checks/draft
	 * @secure
	 */
	saveHealthCheckDraft = (
		data: SaveHealthCheckDraftCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/health-checks/draft`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags HealthCheck
	 * @name FinalizeHealthCheck
	 * @summary Finalizes a health check protocol. All official activities must be present.
	 * @request POST:/v1/health-checks/{id}/finalize
	 * @secure
	 */
	finalizeHealthCheck = (
		id: number,
		data: FinalizeHealthCheckCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/health-checks/${id}/finalize`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetPartsForSales
	 * @summary GET sales order parts attached to product individuals.
	 * @request GET:/v1/installation/part-for-sales
	 * @secure
	 */
	getPartsForSales = (
		query?: {
			/** List of product individuals serial numbers. */
			'serialNumbers[]'?: string[];
		},
		params: RequestParams = {}
	) =>
		this.request<
			PartForSaleDto[],
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/installation/part-for-sales`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetTravelReimbursementUnits
	 * @summary GET travel reimbursement units for commissioning.
	 * @request GET:/v1/installation/travel-reimbursement-units
	 * @secure
	 */
	getTravelReimbursementUnits = (params: RequestParams = {}) =>
		this.request<string[], void | ErrorResponse>({
			path: `/v1/installation/travel-reimbursement-units`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetBrandsByMainSegment
	 * @summary GET Brands by MainSegment like M or I. By default returns marine brands, in case of any errors.
	 * @request GET:/v1/installation/brands-by-main-segment
	 * @secure
	 */
	getBrandsByMainSegment = (
		query?: {
			mainSegment?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			SelectItemDto[],
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/installation/brands-by-main-segment`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetModelsByBrandId
	 * @summary GET Models by BrandId
	 * @request GET:/v1/installation/models
	 * @secure
	 */
	getModelsByBrandId = (
		query?: {
			/** @format int32 */
			brandId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<ModelDto[], DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/installation/models`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetBusinessModels
	 * @summary Returns the list of available agreement business model options.
	 * @request GET:/v1/installation/service-agreement-business-models
	 * @secure
	 */
	getBusinessModels = (params: RequestParams = {}) =>
		this.request<SelectItemDto[], void | ErrorResponse>({
			path: `/v1/installation/service-agreement-business-models`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetServiceTypes
	 * @summary Returns the list of available agreement service type options.
	 * @request GET:/v1/installation/service-agreement-service-types
	 * @secure
	 */
	getServiceTypes = (params: RequestParams = {}) =>
		this.request<SelectItemDto[], void | ErrorResponse>({
			path: `/v1/installation/service-agreement-service-types`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetDemoUse
	 * @summary GET demo use by Id
	 * @request GET:/v1/installation/demo-use
	 * @secure
	 */
	getDemoUse = (
		query?: {
			/** @format int32 */
			id?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<DemoUseDto, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/installation/demo-use`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Installation
	 * @name GetDemoUses
	 * @summary GET demo uses for Unit
	 * @request GET:/v1/installation/demo-uses
	 * @secure
	 */
	getDemoUses = (
		query?: {
			/** @format ShortGuid */
			unitId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<DemoUseDto[], DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/installation/demo-uses`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Sorting, filtering (including owner fields via ECM) and paging is implemented. Owner data is enriched from ECM system. Use the PageIndex to retrieve proper page, TotalResults are only sent in the first page. User with access rights can additionally pass custom customer number.
	 *
	 * @tags MaintenancePlanner
	 * @name GetDealerMaintenanceUnits
	 * @summary Get user maintenance dashboard items with ECM integration.
	 * @request POST:/v1/maintenance-planner/dealer-units
	 * @secure
	 */
	getDealerMaintenanceUnits = (
		data: GetDrivelineMaintenancePlansQuery,
		params: RequestParams = {}
	) =>
		this.request<
			MaintenancePlansResponse,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/maintenance-planner/dealer-units`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom customer number.
	 *
	 * @tags MaintenancePlanner
	 * @name AddItemToCustomerMaintenancePlannerList
	 * @summary Add unit or driveline to user maintenance dashboard items.
	 * @request POST:/v1/maintenance-planner/dealer-drivelines
	 * @secure
	 */
	addItemToCustomerMaintenancePlannerList = (
		query?: {
			chassisId?: string | null;
			/** @format int64 */
			unitId?: number | null;
			/** @format int64 */
			customerNumber?: number | null;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/dealer-drivelines`,
			method: 'POST',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom customer number.
	 *
	 * @tags MaintenancePlanner
	 * @name RemoveItemFromCustomerMaintenancePlannerList
	 * @summary Remove unit or driveline from user maintenance dashboard items.
	 * @request DELETE:/v1/maintenance-planner/dealer-drivelines
	 * @secure
	 */
	removeItemFromCustomerMaintenancePlannerList = (
		query?: {
			/** Array of unitIds to remove from MP */
			'unitIds[]'?: number[];
			/** Array of chassis IDs to remove from MP */
			'chassisIds[]'?: string[];
			/**
			 * CustomerNumber for MP dashboard
			 * @format int64
			 */
			customerNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/dealer-drivelines`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom customer number.
	 *
	 * @tags MaintenancePlanner
	 * @name ScheduleMaintenanceServiceDate
	 * @summary Schedule service date for unit/driveline.
	 * @request POST:/v1/maintenance-planner/service-date/schedule
	 * @secure
	 */
	scheduleMaintenanceServiceDate = (
		query: {
			/** @format date-time */
			serviceDate: Date;
			chassisId?: string | null;
			/** @format int64 */
			unitId?: number | null;
			/** @format int64 */
			customerNumber?: number | null;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/service-date/schedule`,
			method: 'POST',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom customer number.
	 *
	 * @tags MaintenancePlanner
	 * @name DeleteMaintenanceServiceDate
	 * @summary Delete scheduled service date for unit/driveline.
	 * @request DELETE:/v1/maintenance-planner/service-date/delete
	 * @secure
	 */
	deleteMaintenanceServiceDate = (
		query?: {
			chassisId?: string | null;
			/** @format int64 */
			unitId?: number | null;
			/** @format int64 */
			customerNumber?: number | null;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/service-date/delete`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags MaintenancePlanner
	 * @name GetMaintenanceUnitsBySearch
	 * @summary Search for units and drivelines by end customer id or by search phrase.
	 * @request GET:/v1/maintenance-planner/search
	 * @secure
	 */
	getMaintenanceUnitsBySearch = (
		query?: {
			/** @format int32 */
			consumerId?: number | null;
			searchPhrase?: string | null;
			/** @format int64 */
			businessPartnerId?: number | null;
		},
		params: RequestParams = {}
	) =>
		this.request<
			SearchProductMaintenancePlannerDto[],
			void | ErrorResponse
		>({
			path: `/v1/maintenance-planner/search`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom business partner number.
	 *
	 * @tags MaintenancePlanner
	 * @name GetScheduledMaintenanceAlert
	 * @summary Get all scheduled maintenance alerts for the user's business partner.
	 * @request GET:/v1/maintenance-planner/alerts
	 * @secure
	 */
	getScheduledMaintenanceAlert = (
		query?: {
			/** Chassis identification */
			chassisId?: string;
			/**
			 * Optional business partner number (for admin users)
			 * @format int64
			 */
			businessPartnerNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<
			ScheduledMaintenanceAlertDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/maintenance-planner/alerts`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description No validation for chassis existence. User with access rights can additionally pass custom business partner number.
	 *
	 * @tags MaintenancePlanner
	 * @name CreateScheduledMaintenanceAlert
	 * @summary Create a scheduled maintenance alert for a chassis.
	 * @request POST:/v1/maintenance-planner/alerts
	 * @secure
	 */
	createScheduledMaintenanceAlert = (
		data: CreateScheduledMaintenanceAlertCommand,
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/alerts`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description User with access rights can additionally pass custom business partner number.
	 *
	 * @tags MaintenancePlanner
	 * @name UpdateScheduledMaintenanceAlert
	 * @summary Update a scheduled maintenance alert for a chassis.
	 * @request PUT:/v1/maintenance-planner/alerts
	 * @secure
	 */
	updateScheduledMaintenanceAlert = (
		data: UpdateScheduledMaintenanceAlertCommand,
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/alerts`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description No validation for chassis existence. User with access rights can additionally pass custom business partner number.
	 *
	 * @tags MaintenancePlanner
	 * @name DeleteScheduledMaintenanceAlert
	 * @summary Delete a scheduled maintenance alert for a chassis.
	 * @request DELETE:/v1/maintenance-planner/alerts
	 * @secure
	 */
	deleteScheduledMaintenanceAlert = (
		query?: {
			/** Chassis identification. */
			chassisId?: string;
			/**
			 * Business partner number
			 * @format int64
			 */
			businessPartnerNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/maintenance-planner/alerts`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Order
	 * @name GetOrder
	 * @summary Get order information.
	 * @request GET:/v1/order/{orderId}
	 * @secure
	 */
	getOrder = (
		orderId: number,
		query?: {
			/** Serial Number of individual, needed for ship and invoice dates */
			serialNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			OrderInfoDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/order/${orderId}`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Order
	 * @name GetOrderPartsForSale
	 * @summary Get parts from order.
	 * @request GET:/v1/order/{orderId}/other-parts
	 * @secure
	 */
	getOrderPartsForSale = (orderId: number, params: RequestParams = {}) =>
		this.request<
			PartForSaleDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/order/${orderId}/other-parts`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Order
	 * @name GetOrderProductIndividuals
	 * @summary Get product individuals from order.
	 * @request GET:/v1/order/{orderId}/product-individuals
	 * @secure
	 */
	getOrderProductIndividuals = (
		orderId: number,
		params: RequestParams = {}
	) =>
		this.request<
			OrderInfoProductIndividualViewDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/order/${orderId}/product-individuals`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Order
	 * @name GetOrderServices
	 * @summary Get services for order.
	 * @request GET:/v1/order/{orderId}/services
	 * @secure
	 */
	getOrderServices = (orderId: number, params: RequestParams = {}) =>
		this.request<
			ServiceDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/order/${orderId}/services`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Pdf
	 * @name DownloadServiceProtocolPdf
	 * @summary Creates PDF printout of the service protocol
	 * @request POST:/v1/pdf/service-protocol
	 * @secure
	 */
	downloadServiceProtocolPdf = (
		data: {
			vppnReverseProxyType?: string;
			/** @format int32 */
			id?: number;
			/** @format date-time */
			protocolGenerationClientDate?: Date;
			additionalText?: string;
			printQr?: boolean;
			printConfiguration?: boolean;
			printEndCustomer?: boolean;
			printCampaigns?: boolean;
			printCoverage?: boolean;
			pritntProposals?: boolean;
			printEstimatedHours?: boolean;
			printUsedHours?: boolean;
			printActivitiesPhotos?: boolean;
			printAdditionalRepairs?: boolean;
			printAdditionalRepairPhotos?: boolean;
			printSignaures?: boolean;
		},
		query?: {
			/**
			 * Should file be opened by browser or not.
			 * @default false
			 */
			openFile?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/pdf/service-protocol`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Pdf
	 * @name DownloadUnitOverviewPdf
	 * @summary Creates PDF printout of the unit overview
	 * @request POST:/v1/pdf/unit-overview
	 * @secure
	 */
	downloadUnitOverviewPdf = (
		data: {
			/** Indicates whether the request originates from the VPPN frontend and which specific proxy. */
			vppnReverseProxyType?: string;
			/**
			 * The identifier of the unit to generate the PDF for.
			 * @format int64
			 */
			unitId?: number;
			/**
			 * The client-side date and time when the PDF generation was requested.
			 * @format date-time
			 */
			generationClientDate?: Date;
			/** Optional additional text to include in the PDF. */
			additionalText?: string;
			/** Indicates whether to include a QR code linking to the unit overview. */
			printQr?: boolean;
			/** Indicates whether to include the unit configuration section. */
			printConfiguration?: boolean;
			/** Indicates whether to include the end customer section. */
			printEndCustomer?: boolean;
			/** Indicates whether to include the campaigns section. */
			printCampaigns?: boolean;
			/** Indicates whether to include the coverage section. */
			printCoverage?: boolean;
			/** Indicates whether to include the product in operation section. */
			printProductInOperation?: boolean;
			/** Indicates whether to include the commissioning section. */
			printCommissioning?: boolean;
			/** Indicates whether to include the commissioning checklist section. */
			printCommissioningCheckList?: boolean;
			/** Indicates whether to include the signatures section. */
			printSignatures?: boolean;
		},
		query?: {
			/**
			 * Should file be opened by browser or not.
			 * @default false
			 */
			openFile?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/pdf/unit-overview`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Pdf
	 * @name DownloadHealthCheckPdf
	 * @summary Creates PDF printout of the health check
	 * @request POST:/v1/pdf/health-check
	 * @secure
	 */
	downloadHealthCheckPdf = (
		data: {
			/**
			 * The identifier of the health check protocol to generate the PDF for.
			 * @format int64
			 */
			id?: number;
			/**
			 * The client-side date and time when the PDF generation was requested.
			 * @format date-time
			 */
			protocolGenerationClientDate?: Date;
			/** Optional IETF language code used to render the document. */
			language?: string;
			/** Indicates whether the request originates from the VPPN frontend and which specific proxy. */
			vppnReverseProxyType?: string;
			/** Free-text additional information entered by the user, rendered as the "Additional information" section. */
			additionalText?: string;
			/** Indicates whether to include a QR code linking to the health check overview. */
			printQr?: boolean;
			/** Indicates whether to include the estimated hours. */
			printEstimatedHours?: boolean;
			/** Indicates whether to include the used hours. */
			printUsedHours?: boolean;
			/** Indicates whether to include the unit configuration section. */
			printConfiguration?: boolean;
			/** Indicates whether to include the end customer section. */
			printEndCustomer?: boolean;
			/** Indicates whether to include the campaigns section. */
			printCampaigns?: boolean;
			/** Indicates whether to include the coverage section. */
			printCoverage?: boolean;
			/** Indicates whether to include the notes section. */
			printNotes?: boolean;
			/** Indicates whether to include the recommended actions section. */
			printRecommendedActions?: boolean;
			/** Indicates whether to include the signatures section. */
			printSignatures?: boolean;
			/** Indicates whether to include the attached files section. */
			printAttachedFiles?: boolean;
		},
		query?: {
			/**
			 * Should file be opened by browser or not.
			 * @default false
			 */
			openFile?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/pdf/health-check`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags PlmConsume
	 * @name GetPublications
	 * @summary Returns publications matched to serial number
	 * @request GET:/v1/plm-consume/publications
	 * @secure
	 */
	getPublications = (
		query?: {
			/** @format ShortGuid */
			unitId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			PublicationDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/plm-consume/publications`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags PlmConsume
	 * @name GetPublicationFile
	 * @summary Retrieves the binary file associated with a publication specified by the provided UUID.
	 * @request POST:/v1/plm-consume/publication-binary/{uuid}
	 * @secure
	 */
	getPublicationFile = (uuid: string, params: RequestParams = {}) =>
		this.request<File, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/plm-consume/publication-binary/${uuid}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags PlmConsume
	 * @name CheckPublicationFile
	 * @summary Check if a binary file associated with the publication specified by the provided UUID exists
	 * @request GET:/v1/plm-consume/publication-binary-check/{uuid}
	 * @secure
	 */
	checkPublicationFile = (uuid: string, params: RequestParams = {}) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/plm-consume/publication-binary-check/${uuid}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetForeignProductCategories
	 * @summary Get foreign products categories.
	 * @request GET:/v1/product/foreign-product-categories
	 * @secure
	 */
	getForeignProductCategories = (params: RequestParams = {}) =>
		this.request<
			IdLabelSortedDto[],
			ValidationErrorResponse | void | ErrorResponse
		>({
			path: `/v1/product/foreign-product-categories`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetRegistrationPart
	 * @summary Get properties for an item.
	 * @request GET:/v1/product/registration-part
	 * @secure
	 */
	getRegistrationPart = (
		query?: {
			/** Part number */
			partNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<RegistrationItemDto, void | ErrorResponse>({
			path: `/v1/product/registration-part`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetDetailedSegments
	 * @summary Get detailed segments for specified main segment.
	 * @request GET:/v1/product/detailed-segments
	 * @secure
	 */
	getDetailedSegments = (
		query?: {
			mainSegment?: MainSegmentNames | null;
		},
		params: RequestParams = {}
	) =>
		this.request<ListItemDto[], void | ErrorResponse>({
			path: `/v1/product/detailed-segments`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetDetailedSegmentsForRegistration
	 * @summary Get detailed segments for specific main segment and verify if products are eligible to be registered as yacht.
	 * @request POST:/v1/product/detailed-segments
	 * @secure
	 */
	getDetailedSegmentsForRegistration = (
		data: string[],
		query?: {
			/** Main segment to match detailed segments */
			mainSegment?: MainSegmentNames;
		},
		params: RequestParams = {}
	) =>
		this.request<ListItemDto[], void | ErrorResponse>({
			path: `/v1/product/detailed-segments`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetLineOfBusinesses
	 * @summary Retrieves line of business for specified main segment.
	 * @request GET:/v1/product/line-of-business
	 * @secure
	 */
	getLineOfBusinesses = (
		query: {
			mainSegment: MainSegmentNames;
		},
		params: RequestParams = {}
	) =>
		this.request<ListItemDto[], string | void | ErrorResponse>({
			path: `/v1/product/line-of-business`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetUnitPurposes
	 * @summary Retrieves list of unit purposes.
	 * @request GET:/v1/product/unit-purposes
	 * @secure
	 */
	getUnitPurposes = (params: RequestParams = {}) =>
		this.request<ListItemParentDto[], void | ErrorResponse>({
			path: `/v1/product/unit-purposes`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetInstallationPurposes
	 * @summary Retrieves installation purposes for specified detailed segment.
	 * @request GET:/v1/product/installation-purposes
	 * @secure
	 */
	getInstallationPurposes = (
		query: {
			detailedSegment: string;
		},
		params: RequestParams = {}
	) =>
		this.request<InstallationTypeDto[], void | ErrorResponse>({
			path: `/v1/product/installation-purposes`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetOperatingProfiles
	 * @summary Retrieves operating profiles for specified installation purpose.
	 * @request GET:/v1/product/operating-profiles
	 * @secure
	 */
	getOperatingProfiles = (
		query: {
			installationPurpose: InstallationPurpose;
		},
		params: RequestParams = {}
	) =>
		this.request<ListItemDto[], void | ErrorResponse>({
			path: `/v1/product/operating-profiles`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetPartDescriptionForModule
	 * @summary Get description characteristics for specified part.
	 * @request GET:/v1/product/module
	 * @secure
	 */
	getPartDescriptionForModule = (
		query?: {
			/** Part number */
			partNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/product/module`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetPopulation
	 * @summary Get product population.
	 * @request POST:/v1/product/population
	 * @secure
	 */
	getPopulation = (
		data: GetProductPopulationQuery,
		params: RequestParams = {}
	) =>
		this.request<ProductPopulationResponse, void | ErrorResponse>({
			path: `/v1/product/population`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Product
	 * @name GetPopulationExportHeader
	 * @summary Get product population export header.
	 * @request GET:/v1/product/population/export/header
	 * @secure
	 */
	getPopulationExportHeader = (params: RequestParams = {}) =>
		this.request<ProductPopulationExportHeaderDto[], void | ErrorResponse>({
			path: `/v1/product/population/export/header`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description The exported file is named using the current UTC date and time. If no data matches the query, a 204 No Content response is returned to indicate that no export is available.
	 *
	 * @tags Product
	 * @name GetPopulationExport
	 * @summary Exports the product population data as a CSV file based on the specified query parameters.
	 * @request POST:/v1/product/population/export
	 * @secure
	 */
	getPopulationExport = (
		data: {
			/**
			 * Manufacture date start period
			 * @format date
			 */
			periodStart?: string;
			/**
			 * Manufacture date end period
			 * @format date
			 */
			periodEnd?: string;
			/** Main segment */
			mainSegment?: MainSegment;
			/** Product category */
			category?: ProductCategory;
			/** Current location */
			country?: string;
			/** Columns to include in export file */
			includedColumns?: string[];
		},
		query?: {
			/**
			 * true to prompt the browser to display the file inline; false to prompt the user to download the file. The
			 *             default is false.
			 * @default false
			 */
			openFile?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<File, string | void | ErrorResponse>({
			path: `/v1/product/population/export`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description PC.FE.API.Application.DTO.SearchProductIndividual.ProductIndividualSearchDtoResult.InfoSource contains information if product is a part of bigger structure.
	 *
	 * @tags ProductIndividual
	 * @name SearchProductIndividualBySerialNumber
	 * @summary Search for product individual by serial number, that can be used in the unit registration process.
	 * @request GET:/v1/product-individual/search
	 * @secure
	 */
	searchProductIndividualBySerialNumber = (
		query?: {
			/** Product individual serial number */
			serialNumber?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<ProductIndividualSearchDtoResult, void | ErrorResponse>({
			path: `/v1/product-individual/search`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name SearchForProducts
	 * @summary Search for units by search phrase using ECM API for owner information.
	 * @request GET:/v1/product-individual/search-with-structure
	 * @secure
	 */
	searchForProducts = (
		query: {
			/** The search phrase to query products. Searches across unit names, identifications, chassis IDs, and serial numbers. */
			searchPhrase: string;
		},
		params: RequestParams = {}
	) =>
		this.request<SearchProductIndividualDto[], void | ErrorResponse>({
			path: `/v1/product-individual/search-with-structure`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetProductIndividualIdBySerialNumber
	 * @summary Return id of product individual with the specified serial number.
	 * @request GET:/v1/product-individual/{serialNumber}/id
	 * @secure
	 */
	getProductIndividualIdBySerialNumber = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<number, void | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/id`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetProductIndividualComments
	 * @summary Return list of comments added to product individual.
	 * @request GET:/v1/product-individual/{serialNumber}/comment
	 * @secure
	 */
	getProductIndividualComments = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			CommentDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/comment`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetForeignProductIndividualComments
	 * @summary Return list of comments added to foreign product individual.
	 * @request GET:/v1/product-individual/{id}/foreign-comment
	 * @secure
	 */
	getForeignProductIndividualComments = (
		id: number,
		params: RequestParams = {}
	) =>
		this.request<
			CommentDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${id}/foreign-comment`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetProductIndividualDocuments
	 * @summary Return list of documents attached to the product individual.
	 * @request GET:/v1/product-individual/{serialNumber}/documents
	 * @secure
	 */
	getProductIndividualDocuments = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			DocumentDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/documents`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name AddProductIndividualComment
	 * @summary Add new comment to product individual.
	 * @request POST:/v1/product-individual/comment
	 * @secure
	 */
	addProductIndividualComment = (
		data: CreateProductIndividualCommentCommand,
		params: RequestParams = {}
	) =>
		this.request<
			number,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/product-individual/comment`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name AddForeignProductIndividualComment
	 * @summary Add a new comment to foreign product individual.
	 * @request POST:/v1/product-individual/foreign-comment
	 * @secure
	 */
	addForeignProductIndividualComment = (
		data: CreateForeignProductIndividualCommentCommand,
		params: RequestParams = {}
	) =>
		this.request<
			number,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/product-individual/foreign-comment`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Results contains information if product belongs to any unit or a driveline.
	 *
	 * @tags ProductIndividual
	 * @name GetProductIndividualBySerialNumber
	 * @summary Return product individual with additional information.
	 * @request GET:/v1/product-individual/{serialNumber}
	 * @secure
	 */
	getProductIndividualBySerialNumber = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualItemPurposeExtended,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetEditProductIndividualBySerialNumber
	 * @summary Return product individual with additional information for edit.
	 * @request GET:/v1/product-individual/{serialNumber}/edit
	 * @secure
	 */
	getEditProductIndividualBySerialNumber = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualEditDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/edit`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetProductIndividualById
	 * @summary Return product individual with additional information.
	 * @request GET:/v1/product-individual
	 * @secure
	 */
	getProductIndividualById = (
		query?: {
			/** @format int64 */
			id?: number | null;
			serialNumber?: string | null;
		},
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualItemPurposeExtended,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Only for internal developers use.
	 *
	 * @tags ProductIndividual
	 * @name RemoveCommentById
	 * @summary Delete specified comment.
	 * @request DELETE:/v1/product-individual/comment/{id}
	 * @secure
	 */
	removeCommentById = (id: number, params: RequestParams = {}) =>
		this.request<void, void | ErrorResponse>({
			path: `/v1/product-individual/comment/${id}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name ForceSyncIndividual
	 * @summary Run synchronization job for product individual.
	 * @request POST:/v1/product-individual/{serialNumber}/force-sync
	 * @secure
	 */
	forceSyncIndividual = (serialNumber: string, params: RequestParams = {}) =>
		this.request<boolean, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/force-sync`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description * Return campaigns filtered for dealer or internal user * Additionally returns link to campaign publication, but only the VPPC one.
	 *
	 * @tags ProductIndividual
	 * @name GetCampaignsWithoutPolicy
	 * @summary Return campaigns, except for policy type, for product individuals in the unit.
	 * @request GET:/v1/product-individual/{serialNumber}/campaigns
	 * @secure
	 */
	getCampaignsWithoutPolicy = (
		serialNumber: string,
		query?: {
			/** If result set should contain concerned individuals with campaigns performed */
			includePerformed?: boolean;
			/** If result set should contain closed campaigns */
			includeClosed?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<ConcernedIndividualCampaignDto[], void | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/campaigns`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Return campaigns filtered for dealer or internal user
	 *
	 * @tags ProductIndividual
	 * @name GetCampaignsForProductIndividual
	 * @summary Return number of campaigns for individual, except for policy type.
	 * @request GET:/v1/product-individual/{serialNumber}/campaigns-count
	 * @secure
	 */
	getCampaignsForProductIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualCampaignsContractDto,
			void | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/campaigns-count`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description * Return campaigns filtered for dealer or internal user * Additionally returns link to campaign publication, but only the VPPC one.
	 *
	 * @tags ProductIndividual
	 * @name GetOutstandingCampaignsOnlyPolicy
	 * @summary Return active campaigns, only of policy type, for product individuals in the unit.
	 * @request GET:/v1/product-individual/{serialNumber}/campaign-policy
	 * @secure
	 */
	getOutstandingCampaignsOnlyPolicy = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<ConcernedIndividualCampaignDto[], void | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/campaign-policy`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetClaimHistoryForIndividual
	 * @summary Return information about product individual claims history.
	 * @request GET:/v1/product-individual/{serialNumber}/claims
	 * @secure
	 */
	getClaimHistoryForIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			ClaimHistoryInfoDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/claims`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetDetailedClaimInfo
	 * @summary Return detailed information about claim job and parent claim header
	 * @request GET:/v1/product-individual/claims
	 * @secure
	 */
	getDetailedClaimInfo = (
		query?: {
			/**
			 * Id for claim job
			 * @format int32
			 */
			claimJobId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<ClaimHistoryInfoDto, void | ErrorResponse>({
			path: `/v1/product-individual/claims`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetModulesForIndividual
	 * @summary Return modules configuration for product individual.
	 * @request GET:/v1/product-individual/{serialNumber}/module
	 * @secure
	 */
	getModulesForIndividual = (
		serialNumber: string,
		query?: {
			/** only after market modules */
			afterMarket?: boolean;
			/** only as sold modules */
			asSold?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<ModuleDto[], void | NotFoundErrorResponse | ErrorResponse>(
			{
				path: `/v1/product-individual/${serialNumber}/module`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}
		);
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name AddOrChangeIndividualModule
	 * @summary Add or replace module in product individual.
	 * @request POST:/v1/product-individual/{serialNumber}/module
	 * @secure
	 */
	addOrChangeIndividualModule = (
		serialNumber: string,
		data: AddOrChangeModuleProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<
			number,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/module`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name RemoveIndividualModule
	 * @summary Delete module in product individual.
	 * @request DELETE:/v1/product-individual/{serialNumber}/module
	 * @secure
	 */
	removeIndividualModule = (
		serialNumber: string,
		query?: {
			/** Number of module to be deleted */
			moduleNumber?: string;
			/** Reference field? */
			reference?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<number, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/module`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetEventLogsForIndividual
	 * @summary Return events logs for specified product individual.
	 * @request GET:/v1/product-individual/{serialNumber}/event-logs
	 * @secure
	 */
	getEventLogsForIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<EventLogDto[], void | ErrorResponse>({
			path: `/v1/product-individual/${serialNumber}/event-logs`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetLogisticTrailForIndividual
	 * @summary Get logistic trail for product individual, mostly orders information.
	 * @request GET:/v1/product-individual/{serialNumber}/order
	 * @secure
	 */
	getLogisticTrailForIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			OrderInfoDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/order`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetVstCodes
	 * @summary Retrieves list of the VST codes for individual product.
	 * @request GET:/v1/product-individual/{serialNumber}/codes
	 * @secure
	 */
	getVstCodes = (serialNumber: string, params: RequestParams = {}) =>
		this.request<
			VSTCodeDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/codes`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetPartsListForIndividual
	 * @summary Return information about product individual parts (received from factory).
	 * @request GET:/v1/product-individual/{serialNumber}/parts
	 * @secure
	 */
	getPartsListForIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualPartDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/parts`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name GetTechnicalInfoForIndividual
	 * @summary Return information about product individual technical information.
	 * @request GET:/v1/product-individual/{serialNumber}/technical-info
	 * @secure
	 */
	getTechnicalInfoForIndividual = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			TechnicalInfoDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/technical-info`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name EditTechnicalInfoForIndividual
	 * @summary Update some technical information of product individual
	 * @request POST:/v1/product-individual/{serialNumber}/technical-info/edit
	 * @secure
	 */
	editTechnicalInfoForIndividual = (
		serialNumber: string,
		data: EditTechnicalInfoForIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<
			TechnicalInfoDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/technical-info/edit`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
 * No description
 *
 * @tags ProductIndividual
 * @name AssignTemporaryChassis
 * @summary Adds the product individual to the temporary driveline. 
Sets the expiration date of the driveline connection to 90 days.
 * @request POST:/v1/product-individual/{serialNumber}/assign-temporary-chassis
 * @secure
 */
	assignTemporaryChassis = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<
			number,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/product-individual/${serialNumber}/assign-temporary-chassis`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name ScrapProductIndividual
	 * @summary Change product individual status to scrapped.
	 * @request POST:/v1/product-individual/scrap
	 * @secure
	 */
	scrapProductIndividual = (
		data: ScrapProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/product-individual/scrap`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ProductIndividual
	 * @name ReviveProductIndividual
	 * @summary Change product individual status back from scrapped or replaced.
	 * @request POST:/v1/product-individual/revive
	 * @secure
	 */
	reviveProductIndividual = (
		data: ReviveProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/product-individual/revive`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Save individual changes accoridng to recieved data
	 *
	 * @tags ProductIndividual
	 * @name EditIndividualConfiguration
	 * @summary Update product individual.
	 * @request POST:/v1/product-individual/edit
	 * @secure
	 */
	editIndividualConfiguration = (
		data: EditProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<void, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/product-individual/edit`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Save individual as manufactured based on provided data
	 *
	 * @tags ProductIndividual
	 * @name UploadIndividual
	 * @summary Upload product individual.
	 * @request POST:/v1/product-individual/upload
	 * @secure
	 */
	uploadIndividual = (
		data: UploadProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<
			ProductIndividualItemPurposeExtended,
			DomainErrorResponse | void | ValidationErrorResponse | ErrorResponse
		>({
			path: `/v1/product-individual/upload`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name GetReleaseNotes
	 * @summary Get list of Product Center release notes.
	 * @request GET:/v1/releasenote/list
	 * @secure
	 */
	getReleaseNotes = (params: RequestParams = {}) =>
		this.request<PCReleaseNoteList[], void | ErrorResponse>({
			path: `/v1/releasenote/list`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name GetReleaseNoteConetnt
	 * @summary Get Product Center release note content.
	 * @request GET:/v1/releasenote/content/{id}
	 * @secure
	 */
	getReleaseNoteConetnt = (id: number, params: RequestParams = {}) =>
		this.request<PCReleaseNoteContent, void | ErrorResponse>({
			path: `/v1/releasenote/content/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name AddReleaseNote
	 * @summary Add a new release note
	 * @request POST:/v1/releasenote/add
	 * @secure
	 */
	addReleaseNote = (
		data: AddReleaseNoteCommand,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/releasenote/add`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name UpdateReleaseNote
	 * @summary Update an existing release note
	 * @request PUT:/v1/releasenote/update
	 * @secure
	 */
	updateReleaseNote = (
		data: UpdateReleaseNoteCommand,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/releasenote/update`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name RemoveReleaseNote
	 * @summary Remove an existing release note
	 * @request DELETE:/v1/releasenote/remove
	 * @secure
	 */
	removeReleaseNote = (
		data: RemoveReleaseNoteCommand,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/releasenote/remove`,
			method: 'DELETE',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ReleaseNote
	 * @name GetReleaseNoteNotificationStatus
	 * @summary Get notification status
	 * @request GET:/v1/releasenote/notification
	 * @secure
	 */
	getReleaseNoteNotificationStatus = (params: RequestParams = {}) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/releasenote/notification`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Repair
	 * @name GetRepair
	 * @summary Returns repair event details
	 * @request GET:/v1/repair/{repairId}
	 * @secure
	 */
	getRepair = (repairId: number, params: RequestParams = {}) =>
		this.request<RepairDto, void | ErrorResponse>({
			path: `/v1/repair/${repairId}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Repair
	 * @name DeleteRepair
	 * @summary Delete repair event details
	 * @request DELETE:/v1/repair/{repairId}
	 * @secure
	 */
	deleteRepair = (repairId: number, params: RequestParams = {}) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/repair/${repairId}`,
			method: 'DELETE',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Repair
	 * @name GetRepairsBySerialNumbers
	 * @summary Returns repairs for multiple serial numbers
	 * @request POST:/v1/repair/by-serial-numbers
	 * @secure
	 */
	getRepairsBySerialNumbers = (data: string[], params: RequestParams = {}) =>
		this.request<RepairHistoryDto[], void | ErrorResponse>({
			path: `/v1/repair/by-serial-numbers`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name GetUser
	 * @summary Get requestor user data.
	 * @request GET:/v1/security/user
	 * @secure
	 */
	getUser = (params: RequestParams = {}) =>
		this.request<
			UserWithCustomerDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/security/user`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name GetSecurityMatrix
	 * @summary Get requestor security matrix
	 * @request GET:/v1/security/user-security-matrix
	 * @secure
	 */
	getSecurityMatrix = (params: RequestParams = {}) =>
		this.request<SecurityMatrixDto[], void | ErrorResponse>({
			path: `/v1/security/user-security-matrix`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name GetMenu
	 * @summary Get requestor application menu.
	 * @request GET:/v1/security/user-menu
	 * @secure
	 */
	getMenu = (
		query?: {
			vppnReverseProxyType?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<MenuDto[], void | ErrorResponse>({
			path: `/v1/security/user-menu`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name GetSupportedLanguageList
	 * @summary Get supported language list for select language change
	 * @request GET:/v1/security/language-list
	 * @secure
	 */
	getSupportedLanguageList = (params: RequestParams = {}) =>
		this.request<Record<string, string>, void | ErrorResponse>({
			path: `/v1/security/language-list`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name SetUserLanguage
	 * @summary Set user language for requestor.
	 * @request POST:/v1/security/user-language
	 * @secure
	 */
	setUserLanguage = (
		data: SetUserLanguageCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			string | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/security/user-language`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name SetUserRoles
	 * @summary Set user roles for the requestor.
	 * @request POST:/v1/security/user-roles
	 * @secure
	 */
	setUserRoles = (data: SetUserRolesCommand, params: RequestParams = {}) =>
		this.request<
			void,
			string | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/security/user-roles`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name SetUserCustomer
	 * @summary Set user customer for the requestor.
	 * @request POST:/v1/security/user-customer
	 * @secure
	 */
	setUserCustomer = (data: number, params: RequestParams = {}) =>
		this.request<
			void,
			string | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/security/user-customer`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name GetAvailableRoles
	 * @summary Get all available security roles.
	 * @request GET:/v1/security/available-roles
	 * @secure
	 */
	getAvailableRoles = (params: RequestParams = {}) =>
		this.request<string[], void>({
			path: `/v1/security/available-roles`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Security
	 * @name SearchBusinessPartners
	 * @summary Search for business partners using prompt.
	 * @request GET:/v1/security/business-partners
	 * @secure
	 */
	searchBusinessPartners = (
		query?: {
			/** Search prompt, minimum 3 characters required */
			prompt?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<BusinessPartnerDto[], void | ErrorResponse>({
			path: `/v1/security/business-partners`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name CancelServiceProtocol
	 * @summary Cancels finalized service protocol. Reverts current location and operating hours changes on product individuals and unit.
	 * @request POST:/v1/service-protocol/{id}/cancel
	 * @secure
	 */
	cancelServiceProtocol = (id: number, params: RequestParams = {}) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/service-protocol/${id}/cancel`,
			method: 'POST',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name DeleteServiceProtocol
	 * @summary Deletes initiated service protocol.
	 * @request DELETE:/v1/service-protocol/{id}
	 * @secure
	 */
	deleteServiceProtocol = (id: number, params: RequestParams = {}) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/service-protocol/${id}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * @description Response will only contain cancelled protocol, if the requestor has the access rights.
	 *
	 * @tags ServiceProtocol
	 * @name GetServiceProtocol
	 * @summary Get service protocol
	 * @request GET:/v1/service-protocol/{id}
	 * @secure
	 */
	getServiceProtocol = (
		id: number,
		query?: {
			/** Should include service activity events in the response */
			includeEvents?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<
			ServiceProtocolDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/service-protocol/${id}`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name GetLastInitiatedProtocolId
	 * @summary Returns last initiated service protocol id for requested chassis.
	 * @request GET:/v1/service-protocol/last-initiated-protocol-id
	 * @secure
	 */
	getLastInitiatedProtocolId = (
		query?: {
			/** Chassis identification */
			chassisId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<number, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/last-initiated-protocol-id`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will only contain cancelled protocol, if the requestor has the access rights.
	 *
	 * @tags ServiceProtocol
	 * @name GetServiceContent
	 * @summary Get service content
	 * @request GET:/v1/service-protocol/service-activities
	 * @secure
	 */
	getServiceContent = (
		query: {
			chassisSeries: string;
			/** @format int32 */
			chassisNumber: number;
			/** @format date-time */
			serviceDate: Date;
			/** @format date-time */
			productInOperationDate: Date;
			/** @format int32 */
			currentEngineHours?: number | null;
			/** @format int32 */
			currentMWh?: number | null;
			/**
			 * Not required, if there was no previous service protocol. Although user can still pass some date, if protocol was not registered in our system.
			 * @format date-time
			 */
			lastServiceDate?: Date | null;
			/** @format int32 */
			lastServiceEngineHours?: number | null;
			/** @format int32 */
			lastServiceMWh?: number | null;
			/** Preferred language for service protocol, will be used for displaying data and printing PDF. By default set to american english. */
			preferredLanguage: string;
		},
		params: RequestParams = {}
	) =>
		this.request<
			ServiceActivityEventsInfoDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/service-protocol/service-activities`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will return information if service content is available for chassis.
	 *
	 * @tags ServiceProtocol
	 * @name IsServiceContentAvailable
	 * @summary Get service content
	 * @request GET:/v1/service-protocol/service-activities-chassis
	 * @secure
	 */
	isServiceContentAvailable = (
		query: {
			chassisSeries: string;
			/** @format int32 */
			chassisNumber: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/service-activities-chassis`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will retunr information if service content is available for part number.
	 *
	 * @tags ServiceProtocol
	 * @name IsServiceContentAvailableForProductNumber
	 * @summary Get service content
	 * @request GET:/v1/service-protocol/service-activities-part
	 * @secure
	 */
	isServiceContentAvailableForProductNumber = (
		query: {
			productDesignation: string;
			productNumber: string;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/service-activities-part`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will retunr information if service content is available for product designation.
	 *
	 * @tags ServiceProtocol
	 * @name IsServiceContentAvailableForProductDesignation
	 * @summary Get service content
	 * @request GET:/v1/service-protocol/service-activities-designation
	 * @secure
	 */
	isServiceContentAvailableForProductDesignation = (
		query: {
			productDesignation: string;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/service-activities-designation`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name SaveServiceProtocol
	 * @summary Saves and finalizes offline service protocol. Cancels also previous initiated protocols if any.
	 * @request POST:/v1/service-protocol
	 * @secure
	 */
	saveServiceProtocol = (
		data: FinalizeOfflineServiceProtocolCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name SaveServiceProtocolDraft
	 * @summary Saves online service protocol draft. Will set status as initiated.
	 * @request POST:/v1/service-protocol/draft
	 * @secure
	 */
	saveServiceProtocolDraft = (
		data: SaveOnlineServiceProtocolDraftCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/draft`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Response will contain data object with dates which require backend check/calculation.
	 *
	 * @tags ServiceProtocol
	 * @name GetServiceProtocolInitialDates
	 * @summary Get dates for protocol generation
	 * @request GET:/v1/service-protocol/initial-dates
	 * @secure
	 */
	getServiceProtocolInitialDates = (
		query: {
			/** @format int64 */
			drivelineId: number;
		},
		params: RequestParams = {}
	) =>
		this.request<
			GetServiceProtocolInitialDatesDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/service-protocol/initial-dates`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name FinalizeServiceProtocol
	 * @summary Saves and finalizes online service protocol. Cancels also previous initiated protocols if any.
	 * @request POST:/v1/service-protocol/{id}/finalize
	 * @secure
	 */
	finalizeServiceProtocol = (
		id: number,
		data: FinalizeOnlineServiceProtocolCommand,
		params: RequestParams = {}
	) =>
		this.request<number, ValidationErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/${id}/finalize`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ServiceProtocol
	 * @name GetSupportedProtocolLanguageList
	 * @summary Get supported language list for service protocol content
	 * @request GET:/v1/service-protocol/language-list-protocol
	 * @secure
	 */
	getSupportedProtocolLanguageList = (params: RequestParams = {}) =>
		this.request<Record<string, string>, void | ErrorResponse>({
			path: `/v1/service-protocol/language-list-protocol`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Post method is needed to attach authentication token to a file request
	 *
	 * @tags ServiceProtocol
	 * @name GetServiceFileContent
	 * @summary Get service file content
	 * @request POST:/v1/service-protocol/service-file-content
	 * @secure
	 */
	getServiceFileContent = (
		query: {
			/** @format int32 */
			fileId: number;
		},
		params: RequestParams = {}
	) =>
		this.request<void, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/service-protocol/service-file-content`,
			method: 'POST',
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags SoftwareKit
	 * @name GetKits
	 * @summary Get software kits applicable to requested unit.
	 * @request GET:/v1/software-kit/kits
	 * @secure
	 */
	getKits = (
		query?: {
			/**
			 * Unit id
			 * @format ShortGuid
			 */
			unitId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<Kit[], void | ErrorResponse>({
			path: `/v1/software-kit/kits`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Support
	 * @name OrderInfoForSerial
	 * @summary Get order info by serial number
	 * @request GET:/v1/support/order-info/{serialNumber}
	 * @secure
	 */
	orderInfoForSerial = (serialNumber: string, params: RequestParams = {}) =>
		this.request<OrderInfoForSerialDto, void>({
			path: `/v1/support/order-info/${serialNumber}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Support
	 * @name ReprocessSalesOrderForSerial
	 * @request POST:/v1/support/order-reprocess/{serialNumber}
	 * @secure
	 */
	reprocessSalesOrderForSerial = (
		serialNumber: string,
		params: RequestParams = {}
	) =>
		this.request<number, void | ErrorResponse>({
			path: `/v1/support/order-reprocess/${serialNumber}`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Support
	 * @name ForceCancelOrders
	 * @summary Validates the chassis exists and forces cancellation of its software kit orders
	 * @request POST:/v1/support/force-cancel-orders
	 * @secure
	 */
	forceCancelOrders = (
		query?: {
			chassisSeries?: string;
			/** @format int32 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/support/force-cancel-orders`,
			method: 'POST',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetUnitInfoById
	 * @summary Returns unit information.
	 * @request GET:/v1/unit/{unitId}/info
	 * @secure
	 */
	getUnitInfoById = (unitId: string, params: RequestParams = {}) =>
		this.request<UnitInfoDto, void | NotFoundErrorResponse | ErrorResponse>(
			{
				path: `/v1/unit/${unitId}/info`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}
		);
	/**
	 * @description Measurement part is only viable for marine units.
	 *
	 * @tags Unit
	 * @name UpdateUnitInfo
	 * @summary Updates information about the unit.
	 * @request POST:/v1/unit/{unitId}/info
	 * @secure
	 */
	updateUnitInfo = (
		unitId: string,
		data: UnitInfoDtoBase,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/info`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
 * No description
 *
 * @tags Unit
 * @name ResolveUnitIdsFromUrlVisibleToUser
 * @summary Resolve UnitId from URLs visible to user,
such urls must always have ShortGuid PublicId OR long Id from SyncUnit messages (HiLoId for older Units or PK Id for newer)
 * @request GET:/v1/unit/{unitIdFromUrlVisibleToUser}/unitIds
 * @secure
 */
	resolveUnitIdsFromUrlVisibleToUser = (
		unitIdFromUrlVisibleToUser: string,
		params: RequestParams = {}
	) =>
		this.request<UnitIds, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/unit/${unitIdFromUrlVisibleToUser}/unitIds`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Filtering is available.
	 *
	 * @tags Unit
	 * @name GetConnectedUnits
	 * @summary Returns list of units, which are connected to the specified consumer/end customer.
	 * @request GET:/v1/unit/connected-units
	 * @secure
	 */
	getConnectedUnits = (
		query: {
			/** @format int32 */
			consumerId: number;
			mainSegment?: MainSegment | null;
			name?: string | null;
			status?: string | null;
			brand?: string | null;
			model?: string | null;
			hullId?: string | null;
			mmsi?: string | null;
			imo?: string | null;
			callsign?: string | null;
			machineId?: string | null;
		},
		params: RequestParams = {}
	) =>
		this.request<ConnectedUnit[], void | ErrorResponse>({
			path: `/v1/unit/connected-units`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Includes: * Product individual comments * Product individual campaign info
	 *
	 * @tags Unit
	 * @name GetUnitStructureById
	 * @summary Returns unit information with whole unit structure.
	 * @request GET:/v1/unit/{unitId}/structure
	 * @secure
	 */
	getUnitStructureById = (unitId: string, params: RequestParams = {}) =>
		this.request<
			UnitStructureDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/structure`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetUnitEvcStatus
	 * @summary Returns unit EVC status
	 * @request GET:/v1/unit/{unitId}/evc-status
	 * @secure
	 */
	getUnitEvcStatus = (unitId: string, params: RequestParams = {}) =>
		this.request<
			EvcUnitStatusResponse,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/evc-status`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name RegisterUnit
	 * @summary Register new unit.
	 * @request POST:/v1/unit/register
	 * @secure
	 */
	registerUnit = (data: UnitRegisterCommand, params: RequestParams = {}) =>
		this.request<
			UnitRegistrationSummaryDto,
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/unit/register`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Possible to add or edit installations, drivelines and product individuals.
	 *
	 * @tags Unit
	 * @name EditUnitConfiguration
	 * @summary Update unit configuration.
	 * @request POST:/v1/unit/configuration
	 * @secure
	 */
	editUnitConfiguration = (
		data: EditUnitConfigurationCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/configuration`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name CreateOrUpdateUnitLocation
	 * @summary Update unit current location.
	 * @request POST:/v1/unit/location
	 * @secure
	 */
	createOrUpdateUnitLocation = (
		data: CreateOrUpdateUnitLocationCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/location`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Response is strictly tailored for the frontend app.
	 *
	 * @tags Unit
	 * @name CompareVariants
	 * @summary Get list of variants for drivelines inside the unit.
	 * @request GET:/v1/unit/{unitId}/variants
	 * @secure
	 */
	compareVariants = (unitId: string, params: RequestParams = {}) =>
		this.request<
			VariantComparison,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/variants`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetOtherPartsForUnit
	 * @summary Retrieves unit parts info, ordered and installed in unit.
	 * @request GET:/v1/unit/{unitId}/parts
	 * @secure
	 */
	getOtherPartsForUnit = (unitId: string, params: RequestParams = {}) =>
		this.request<
			UnitOtherPartsDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/parts`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name UpdateOtherPartsForUnit
	 * @summary Updates list of unit parts.
	 * @request POST:/v1/unit/parts
	 * @secure
	 */
	updateOtherPartsForUnit = (
		data: UpdateOtherPartsForUnitCommand,
		params: RequestParams = {}
	) =>
		this.request<void, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/unit/parts`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Files should be already uploaded using <a href="/v1/file/upload-temporary-file">/v1/file/upload-temporary-file</a>
	 *
	 * @tags Unit
	 * @name AdditionalFiles
	 * @summary Attach additional files to unit.
	 * @request POST:/v1/unit/additional-files
	 * @secure
	 */
	additionalFiles = (
		data: CreateAdditionalFilesCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/additional-files`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetHealthCheckFiles
	 * @summary Retrieves all health check files associated with the specified unit.
	 * @request GET:/v1/unit/health-check/files/unit/{unitId}
	 * @secure
	 */
	getHealthCheckFiles = (unitId: number, params: RequestParams = {}) =>
		this.request<
			HealthCheckFilesDto,
			string | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/health-check/files/unit/${unitId}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
 * No description
 *
 * @tags Unit
 * @name ImportAdditionalFilesToHealthCheck
 * @summary Transfer already uploaded files from a unit's additional-files (Unit information tab) file sets into
the unit's health check files. No physical file move is performed — both share the same storage path.
 * @request POST:/v1/unit/{unitId}/additional-files/import-to-health-check
 * @secure
 */
	importAdditionalFilesToHealthCheck = (
		unitId: number,
		data: ImportAdditionalFilesToHealthCheckCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/unit/${unitId}/additional-files/import-to-health-check`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetOwnerAndUnitManagerEcm
	 * @summary Retrieve ECM end customers (an owner and a manager) related to the unit.
	 * @request GET:/v1/unit/{unitId}/ecm/end-customers
	 * @secure
	 */
	getOwnerAndUnitManagerEcm = (unitId: string, params: RequestParams = {}) =>
		this.request<
			OwnerAndUnitManagerDto,
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/ecm/end-customers`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetProductInOperationData
	 * @summary Retrieves data for process - product in operation.
	 * @request GET:/v1/unit/{unitId}/product-in-operation
	 * @secure
	 */
	getProductInOperationData = (unitId: string, params: RequestParams = {}) =>
		this.request<ProductInOperationDto, void | ErrorResponse>({
			path: `/v1/unit/${unitId}/product-in-operation`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name PerformProductInOperation
	 * @summary Perform process product in operation for a unit.
	 * @request POST:/v1/unit/{unitId}/product-in-operation
	 * @secure
	 */
	performProductInOperation = (
		unitId: string,
		data: CreateUpdateProductInOperationCommand,
		params: RequestParams = {}
	) =>
		this.request<
			WarrantyVerification,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/product-in-operation`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name CommissioningData
	 * @summary Retrieves data for process - commissioning.
	 * @request GET:/v1/unit/{unitId}/commissioning
	 * @secure
	 */
	commissioningData = (unitId: string, params: RequestParams = {}) =>
		this.request<CommissioningDto, void | ErrorResponse>({
			path: `/v1/unit/${unitId}/commissioning`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name PerformCommissioning
	 * @summary Perform commissioning process for a unit.
	 * @request POST:/v1/unit/{unitId}/commissioning
	 * @secure
	 */
	performCommissioning = (
		unitId: string,
		data: CreateOrUpdateCommissioningCommand,
		params: RequestParams = {}
	) =>
		this.request<
			boolean,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/commissioning`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetActiveServiceAgreement
	 * @summary Check if unit has any active service agreement.
	 * @request GET:/v1/unit/{unitId}/active-service-agreement
	 * @secure
	 */
	getActiveServiceAgreement = (unitId: string, params: RequestParams = {}) =>
		this.request<ServiceAgreementDto, void | ErrorResponse>({
			path: `/v1/unit/${unitId}/active-service-agreement`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetServiceAgreements
	 * @summary Get all service agreements for the unit.
	 * @request GET:/v1/unit/{unitId}/service-agreements
	 * @secure
	 */
	getServiceAgreements = (
		unitId: string,
		query?: {
			/** Filter by active agreements */
			active?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<ServiceAgreementDto[], void | ErrorResponse>({
			path: `/v1/unit/${unitId}/service-agreements`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name CreateOrUpdateServiceAgreement
	 * @summary Add or update service agreement for unit.
	 * @request POST:/v1/unit/{unitId}/service-agreements
	 * @secure
	 */
	createOrUpdateServiceAgreement = (
		unitId: string,
		data: CreateOrUpdateServiceAgreementCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/service-agreements`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name AnnulServiceAgreement
	 * @summary Annul a service agreement for the unit.
	 * @request POST:/v1/unit/{unitId}/service-agreements/{agreementId}/annul
	 * @secure
	 */
	annulServiceAgreement = (
		unitId: string,
		agreementId: number,
		data: AnnulServiceAgreementCommand,
		params: RequestParams = {}
	) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/service-agreements/${agreementId}/annul`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description * Return campaigns filtered for dealer or internal user * Additionally returns link to campaign publication, but only the VPPC one.
	 *
	 * @tags Unit
	 * @name GetUnitCampaignsWithoutPolicy
	 * @summary Return campaigns, except for policy type, for product individuals in the unit.
	 * @request GET:/v1/unit/{unitId}/campaigns
	 * @secure
	 */
	getUnitCampaignsWithoutPolicy = (
		unitId: string,
		query?: {
			/** If result set should contain concerned individuals with campaigns performed */
			includePerformed?: boolean;
			/** If result set should contain closed campaigns */
			includeClosed?: boolean;
			/** Get campaigns for internal roles or for external roles */
			queryAsExternal?: boolean;
		},
		params: RequestParams = {}
	) =>
		this.request<ConcernedIndividualCampaignDto[], void | ErrorResponse>({
			path: `/v1/unit/${unitId}/campaigns`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description At the moment accepts only one image, as profile picture. Previous one will be replaced.
	 *
	 * @tags Unit
	 * @name UploadImage
	 * @summary Add jpeg image to unit.
	 * @request POST:/v1/unit/{unitId}/images
	 * @secure
	 */
	uploadImage = (
		unitId: string,
		data: {
			/**
			 * Picture content
			 * @format binary
			 */
			file?: File;
		},
		params: RequestParams = {}
	) =>
		this.request<
			number,
			ValidationFailure[] | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/images`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name DeleteImage
	 * @summary Delete image for the specified unit.
	 * @request DELETE:/v1/unit/{unitId}/images
	 * @secure
	 */
	deleteImage = (
		unitId: string,
		query?: {
			/**
			 * Image id
			 * @format int32
			 */
			imageId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<number, void | ErrorResponse>({
			path: `/v1/unit/${unitId}/images`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name ReplaceIndividual
	 * @summary Replace product individual in the unit.
	 * @request POST:/v1/unit/{unitId}/replace-individual
	 * @secure
	 */
	replaceIndividual = (
		unitId: string,
		data: ReplaceProductIndividualCommand,
		params: RequestParams = {}
	) =>
		this.request<
			boolean,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/replace-individual`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name SwapIndividual
	 * @summary Swap product individual with another one.
	 * @request POST:/v1/unit/{unitId}/swap-individual
	 * @secure
	 */
	swapIndividual = (
		unitId: string,
		data: SwapIndividualInDrivelinesCommand,
		params: RequestParams = {}
	) =>
		this.request<
			boolean,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/swap-individual`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name ForceUnitSync
	 * @summary Run synchronization job for unit.
	 * @request POST:/v1/unit/{unitId}/force-sync
	 * @secure
	 */
	forceUnitSync = (unitId: string, params: RequestParams = {}) =>
		this.request<void, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/unit/${unitId}/force-sync`,
			method: 'POST',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name DeleteUnit
	 * @summary Delete unit
	 * @request DELETE:/v1/unit/{unitId}
	 * @secure
	 */
	deleteUnit = (unitId: string, params: RequestParams = {}) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}`,
			method: 'DELETE',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetCoveragesForUnit
	 * @summary Retrieves warranty coverage data for all the drivelines in the unit.
	 * @request GET:/v1/unit/{unitId}/coverages
	 * @secure
	 */
	getCoveragesForUnit = (unitId: string, params: RequestParams = {}) =>
		this.request<
			DrivelineCoveragesDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/coverages`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetEventLogsForUnit
	 * @summary Retrieves eventlog data for all levels in the unit (individual/driveline/unit).
	 * @request GET:/v1/unit/{unitId}/eventlogs
	 * @secure
	 */
	getEventLogsForUnit = (unitId: string, params: RequestParams = {}) =>
		this.request<
			EventLogDto[],
			void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/eventlogs`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name UpdateEvcDriveline
	 * @summary Updates EVC driveline based on VDA parameters, only possible if EVC status equals Updated.
	 * @request POST:/v1/unit/{unitId}/update-evc-driveline
	 * @secure
	 */
	updateEvcDriveline = (unitId: string, params: RequestParams = {}) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/${unitId}/update-evc-driveline`,
			method: 'POST',
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name GetSyncUnitId
	 * @summary Get Unit Id used for SyncUnit
	 * @request GET:/v1/unit/{unitId}/sync-unit-id
	 * @secure
	 */
	getSyncUnitId = (unitId: string, params: RequestParams = {}) =>
		this.request<number, void | NotFoundErrorResponse | ErrorResponse>({
			path: `/v1/unit/${unitId}/sync-unit-id`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name RegisterDemoUseUnit
	 * @summary Register demo use for Unit
	 * @request POST:/v1/unit/{unitId}/demo-use
	 * @secure
	 */
	registerDemoUseUnit = (
		unitId: string,
		data: RegisterDemoUseCommand,
		params: RequestParams = {}
	) =>
		this.request<
			WarrantyVerification,
			| ValidationErrorResponse
			| void
			| NotFoundErrorResponse
			| ErrorResponse
		>({
			path: `/v1/unit/${unitId}/demo-use`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Unit
	 * @name RelocateUnit
	 * @summary Update unit current location or business partner
	 * @request POST:/v1/unit/relocate-to
	 * @secure
	 */
	relocateUnit = (data: UnitRelocateToCommand, params: RequestParams = {}) =>
		this.request<
			void,
			DomainErrorResponse | void | NotFoundErrorResponse | ErrorResponse
		>({
			path: `/v1/unit/relocate-to`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name GetRecentlyVisited
	 * @summary Get srecently visited info
	 * @request GET:/v1/user/recently-visisted
	 * @secure
	 */
	getRecentlyVisited = (params: RequestParams = {}) =>
		this.request<UserRecentlyVisitedDto[], void | ErrorResponse>({
			path: `/v1/user/recently-visisted`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name UpdateRecentlyVisitedInfo
	 * @summary Save information about visited page for user
	 * @request POST:/v1/user/recently-visisted
	 * @secure
	 */
	updateRecentlyVisitedInfo = (
		data: RecentlyVisitedCommand,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/user/recently-visisted`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name DeleteRecentlyVisitedInfo
	 * @summary Delete information about visited page for user
	 * @request DELETE:/v1/user/recently-visited-by-unit/{unitId}
	 * @secure
	 */
	deleteRecentlyVisitedInfo = (unitId: number, params: RequestParams = {}) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/user/recently-visited-by-unit/${unitId}`,
			method: 'DELETE',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name GetUserVisibilitySettings
	 * @summary Get user visibility settings (on/off) for a type
	 * @request GET:/v1/user/settings/visibility
	 * @secure
	 */
	getUserVisibilitySettings = (
		query: {
			category: SettingsCategory;
		},
		params: RequestParams = {}
	) =>
		this.request<UserVisibilitySettingsDto, void | ErrorResponse>({
			path: `/v1/user/settings/visibility`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name SetUserVisibilitySettings
	 * @summary Save user visibility settings (on/off) for a type
	 * @request POST:/v1/user/settings/visibility
	 * @secure
	 */
	setUserVisibilitySettings = (
		data: SaveUserSettingsCommandStringBoolean,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/user/settings/visibility`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name GetUserTabsSettings
	 * @summary Get user tabs settings (list) for a type
	 * @request GET:/v1/user/settings/tabs
	 * @secure
	 */
	getUserTabsSettings = (
		query: {
			category: SettingsCategory;
		},
		params: RequestParams = {}
	) =>
		this.request<UserTabsSettingsDto, void | ErrorResponse>({
			path: `/v1/user/settings/tabs`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags User
	 * @name SetUserTabsSettings
	 * @summary Save user tabs settings (list) for a type
	 * @request POST:/v1/user/settings/tabs
	 * @secure
	 */
	setUserTabsSettings = (
		data: SaveUserSettingsCommandTabsTypesIListString,
		params: RequestParams = {}
	) =>
		this.request<string, void | ErrorResponse>({
			path: `/v1/user/settings/tabs`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name CheckIfUnitIsEmob
	 * @summary Performs check if unit is of an electric mobility type.
	 * @request GET:/v1/vda/emob-unit
	 * @secure
	 */
	checkIfUnitIsEmob = (
		query?: {
			/**
			 * Unit id
			 * @format int64
			 */
			unitId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, string | void | ErrorResponse>({
			path: `/v1/vda/emob-unit`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name CheckIfUnitHasTelematics
	 * @summary Performs check if unit has telematics.
	 * @request GET:/v1/vda/telematics-unit
	 * @secure
	 */
	checkIfUnitHasTelematics = (
		query?: {
			/** Unit id */
			unitId?: string;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, string | void | ErrorResponse>({
			path: `/v1/vda/telematics-unit`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name GetComponentsAndSoftware
	 * @summary Retrieves first level of the components and software parameters for a chassis.
	 * @request GET:/v1/vda/components-and-software
	 * @secure
	 */
	getComponentsAndSoftware = (
		query?: {
			/** Chassis identification series */
			chassisSeries?: string;
			/**
			 * Chassis identification number
			 * @format int32
			 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<ComponentAndSoftwareDto[], void | ErrorResponse>({
			path: `/v1/vda/components-and-software`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name GetComponentsAndSoftwareChildren
	 * @summary Returns list of components and software parameters that are children to a node.
	 * @request GET:/v1/vda/components-and-software-children
	 * @secure
	 */
	getComponentsAndSoftwareChildren = (
		query?: {
			/**
			 * Node id
			 * @format int32
			 */
			nodeId?: number;
			/** Node type */
			nodeType?: NodeType;
		},
		params: RequestParams = {}
	) =>
		this.request<ComponentAndSoftwareDto[], void | ErrorResponse>({
			path: `/v1/vda/components-and-software-children`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Exported file contains first level and all the children nodes.
	 *
	 * @tags Vda
	 * @name GetComponentsAndSoftwareCsvExport
	 * @summary Returns components and software parameters for a chassis exported to CSV file.
	 * @request POST:/v1/vda/components-and-software-csv
	 * @secure
	 */
	getComponentsAndSoftwareCsvExport = (
		query?: {
			/** Chassis identification series */
			chassisSeries?: string;
			/**
			 * Chassis identification number
			 * @format int32
			 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<void, void | ErrorResponse>({
			path: `/v1/vda/components-and-software-csv`,
			method: 'POST',
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name CheckIfDrivelineIsEvc2
	 * @summary Checks if the driveline/chassis is of type EVC 2.0.
	 * @request GET:/v1/vda/evc2-driveline
	 * @secure
	 */
	checkIfDrivelineIsEvc2 = (
		query?: {
			/** Chassis identification series */
			chassisSeries?: string;
			/**
			 * Chassis identification number
			 * @format int32
			 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/vda/evc2-driveline`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name GetDrivelineControlSystemInfo
	 * @summary Retrieves information about control system inside the requested chassis.
	 * @request GET:/v1/vda/driveline-control-system-info
	 * @secure
	 */
	getDrivelineControlSystemInfo = (
		query?: {
			/** Chassis identification series */
			chassisSeries?: string;
			/**
			 * Chassis identification number
			 * @format int32
			 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<DrivelineControlSystemInfo, void | ErrorResponse>({
			path: `/v1/vda/driveline-control-system-info`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name IsVmmResettable
	 * @summary Performs check if the VMM reset can be performed on the driveline/chassis.
	 * @request GET:/v1/vda/vmm-resetable
	 * @secure
	 */
	isVmmResettable = (
		query?: {
			/**
			 * Driveline id
			 * @format int64
			 */
			drivelineId?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<boolean, void | ErrorResponse>({
			path: `/v1/vda/vmm-resetable`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name PerformVmmReset
	 * @summary Performs VMM reset on the requested driveline/chassis.
	 * @request POST:/v1/vda/vmm-reset
	 * @secure
	 */
	performVmmReset = (data: ResetVmmCommand, params: RequestParams = {}) =>
		this.request<boolean, DomainErrorResponse | void | ErrorResponse>({
			path: `/v1/vda/vmm-reset`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Vda
	 * @name GetSoftwareParameters
	 * @summary Retrieves TEA, TEA2, TEA2Plus software parameters for a chassis.
	 * @request GET:/v1/vda/software-parameters
	 * @secure
	 */
	getSoftwareParameters = (
		query?: {
			/** Chassis identification series */
			chassisSeries?: string;
			/**
			 * Chassis identification number
			 * @format int32
			 */
			chassisNumber?: number;
		},
		params: RequestParams = {}
	) =>
		this.request<
			SoftwareParameterDto[],
			DomainErrorResponse | void | ErrorResponse
		>({
			path: `/v1/vda/software-parameters`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
}
